module.exports = __webpack_public_path__ + "static/media/id-1.4fe428e1.jpg";